<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <b-card-text>
      <div id="listUser" class="list-user">
        <div class="container dashboard admin-company">
          <b-row>
            <b-col cols="12" xl="8" class="col-left-0 col-right-0">
              <div class="list-user--table">
                <div class="header-table header-table-pd20">
                  <h2 class="heading2">
                  </h2>
                </div>
                <div class="dashboard_statistic">
                  <b-row>
                    <b-col cols="6" class="col-left">
                      <div class="dashboard_admin_statistic dashboard_admin_statistic-green d-flex justify-content-start dashboard_admin_statistic-height">
                        <img src="@img/company-profile/number-employee.svg" class="dashboard_admin_imgStatistic" />
                        <div class="dashboard_admin_statistic_parent">
                          <div class="dashboard_statistic_title">社員数</div>
                          <div class="dashboard_admin_statistic_number">{{ formatNumberDashBoard(summary.total_staffs) }}</div>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="6" class="col-right">
                      <div class="dashboard_admin_statistic dashboard_admin_statistic-orange d-flex justify-content-start dashboard_admin_statistic-height">
                        <img src="@img/company-profile/number-file.svg" class="dashboard_admin_imgStatistic" />
                        <div class="dashboard_admin_statistic_parent">
                          <div class="dashboard_statistic_title">合計</div>
                          <div class="dashboard_admin_statistic_number">{{ formatNumberDashBoard(summary.total_files) }}</div>
                          <div class="dashboard_statistic_title">新着</div>
                          <div class="dashboard_admin_statistic_number">{{ formatNumberDashBoard(summary.total_new_files) }}</div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="header-table header-table-custom mb-pd-0">
                  <b-row>
                    <b-col md="6">
                      <h2 class="heading2">
                        ファイル ランキング
                      </h2>
                    </b-col>
                    <b-col md="6">
                      <div class="filter-wrapper d-none d-md-block">
                        <b-form inline class="float-md-right">
                          <b-form-input
                              id="sort-order-data"
                              class="input-form"
                              type="search"
                              placeholder="Search"
                              v-model="paginations.searchQuery"
                              @input="onSearch(paginations.searchQuery)"
                          ></b-form-input>
                      </b-form>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="body-table pd-mb-15">
                  <table class="table table-csUser">
                    <thead>
                    <tr>
                      <th class="w-5"></th>
                      <th scope="col">名前</th>
                      <th scope="col" class="hidden-mb text-center w-20">作成者</th>
                      <th scope="col" class="hidden-mb text-center w-20">更新日</th>
                      <th scope="col" class="mb-width text-center w-15">観覧回数</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="file in rankingFile" v-bind:key="file.rank">
                      <td v-if="file.rank === 1" class="db-border-bottom text-center dashboard-role w-5">
                        <img src="@img/company-profile/number-1.svg" class="dashboard_imgNumber"/>
                      </td>
                      <td v-else-if="file.rank === 2" class="db-border-bottom text-center dashboard-role w-5">
                        <img src="@img/company-profile/number-2.svg" class="dashboard_imgNumber"/>
                      </td>
                      <td v-else-if="file.rank === 3" class="db-border-bottom text-center dashboard-role w-5">
                        <img src="@img/company-profile/number-3.svg" class="dashboard_imgNumber"/>
                      </td>
                      <td v-else class="db-border-bottom text-center dashboard-role w-5">{{ file.rank }}</td>
                      <td scope="row" class="table-name db-border-bottom">
                        <div class="table-name--box align-items-center">
                          <div class="avt-db"><img @click.prevent="detailFile(file.file_id)" :src="file.icon_url" alt="" class="db-img"/></div>
                          <div @click.prevent="detailFile(file.file_id)" class="admin-name">
                            <a href="#" class="name-file line-1 d-none d-lg-block">{{ truncate(file.name,12,'...') }}</a>
                            <a href="#" class="name-file line-1 d-block d-lg-none">{{ truncate(file.name,8,'...') }}</a>
                          </div>
                        </div>
                      </td>
                      <td class="table-department db-border-bottom hidden-mb text-center mw-db-author">
                        <b-link class="name-author" :to="{name: 'admin_employees_detail', params: {id: $route.params.id ,employee_id: file.author_id}}">{{ truncate(file.author_name,7,'...') }}</b-link>
                      </td>
                      <td class="table-role db-border-bottom hidden-mb text-center">{{ dateFormat(file.updated_time) }}</td>
                      <td class="table-phone db-border-bottom text-center">
                        {{ formatNumber(file.total_views) }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xl="4" class="col-left-0 col-right-0">
              <div class="header-table header-table-nopd header-table-mb">
                <h2 class="heading2 pd-mb-15 searchable-heading">
                  <span v-if="!showCloseSearch">観覧社員ランキング</span>
                  <div v-if="showCloseSearch" class="search-field-wrapper">
                    <b-form-input autocomplete="off" v-model="paginations.searchEmpQuery" @input="onSearchEmployeeRanking(paginations.searchEmpQuery)" class="input-form" id="search" type="text" placeholder="検索"></b-form-input>
                  </div>
                  <div class="filter-wrapper ml-auto d-none d-md-block">
                      <button class="btn--filter mr-14 btn-search" @click="showCloseSearch = !showCloseSearch; paginations.searchEmpQuery = ''">
                        <svg v-if="!showCloseSearch" id="Group_3" data-name="Group 3" xmlns="http://www.w3.org/2000/svg" width="20.15" height="20.165" viewBox="0 0 20.15 20.165">
                          <path id="Path_9" data-name="Path 9" d="M8.5,16.608a8.3,8.3,0,1,1,8.3-8.3A8.313,8.313,0,0,1,8.5,16.608Zm0-15.034A6.73,6.73,0,1,0,15.23,8.3,6.737,6.737,0,0,0,8.5,1.574ZM20.115,19.935a.787.787,0,0,0,0-1.113L16.593,15.3a.787.787,0,0,0-1.113,1.113L19,19.935a.787.787,0,0,0,1.113,0Z" transform="translate(-0.196 0)" fill="#748175"/>
                        </svg>
                        <svg v-if="showCloseSearch" class="closeIcon" height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                      </button>
                  </div>
                </h2>
              </div>
              <div class="body-table pd-mb-15">
                <table class="table table-csUser table-mb0-mb dashboard-table">
                  <thead>
                  <tr>
                    <th class="w-5"></th>
                    <th scope="col">社員名</th>
                    <th scope="col" class="text-center w-27 mb-w-23">観覧回数</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="user in rankingUser" v-bind:key="user.rank">
                    <td v-if="user.rank === 1" class="db-border-bottom text-center dashboard-role img-rank-db w-5">
                      <img src="@img/company-profile/number-1.svg" class="dashboard_imgNumber"/>
                    </td>
                    <td v-else-if="user.rank === 2" class="db-border-bottom text-center dashboard-role w-5">
                      <img src="@img/company-profile/number-2.svg" class="dashboard_imgNumber"/>
                    </td>
                    <td v-else-if="user.rank === 3" class="db-border-bottom text-center dashboard-role w-5">
                      <img src="@img/company-profile/number-3.svg" class="dashboard_imgNumber"/>
                    </td>
                    <td v-else class="db-border-bottom text-center dashboard-role w-5">{{ user.rank }}</td>
                    <td scope="row" class="table-name db-border-bottom">
                      <div class="table-name--box align-items-center">
                        <img :src="user.avatar" alt="" class="avt40 avt-db-h" @click.prevent="detailUser(user.employee_id)"/>
                        <div class="admin-name flex-wrap">
                          <a @click.prevent="detailUser(user.employee_id)" href="#" class="name-bold w-100 d-block">{{ truncate(user.employee_name,8,'...') }}</a>
                          <div class="id id-company word-break maxw-name">コード: {{ truncate(user.employee_code,8,'...') }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="table-department db-border-bottom text-center">
                      {{ formatNumber(user.total_views) }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </div>
        <ModalFileOpen/>
      </div>
    </b-card-text>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import Tabs from '@/components/Admin/Company/Tabs'
import Sidebar from '@/views/Admin/Company/Sidebar'
import ModalFileOpen from '@/views/Admin/FolderManagement/ViewFile'
import { BModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
export default {
  name: 'admin_detail_vendor_information',
  components: {
    Sidebar,
    Header,
    Tabs,
    BModal,
    ModalFileOpen
  },
  data () {
    return {
      tabIndex: 2,
      paginations: {
        searchQuery: '',
        searchEmpQuery: '',
        typingTimer: null
      },
      tempRanks: {},
      tempUserRanks: {},
      showCloseSearch: false
    }
  },
  methods: {
    editVendor () {
      const id = this.$route.params.id
      this.$router.push(`/admin/companies/edit/${id}`)
    },
    detailUser (id) {
      this.$router.push(`/admin/companies/${this.$route.params.id}/employees/${id}`)
    },
    detailFile (id) {
      this.$store.dispatch('adminFolder/detailFile', {id: id})
      this.$root.$emit('bv::show::modal', 'modalViewFile', '#modalViewFile')
    },
    onSearch (keyword) {
      clearTimeout(this.paginations.typingTimer)
      if (keyword === '') {
        this.paginations = {}
        this.$store.dispatch('dashboardEmployee/getRankingFile', {id: this.$route.params.id}); return
      }
      this.paginations.typingTimer = setTimeout(() => {
        this.paginations.searchQuery = keyword
        this.$store.dispatch('dashboardEmployee/getRankingFile', {id: this.$route.params.id, searchQuery: this.paginations.searchQuery})
      }, 500)
    },
    onSearchEmployeeRanking (keyword) {
      clearTimeout(this.paginations.typingTimer)
      if (keyword === '') {
        this.paginations = {}
        this.$store.dispatch('dashboardEmployee/getRankingUser', {id: this.$route.params.id}); return
      }
      this.paginations.typingTimer = setTimeout(() => {
        this.paginations.searchEmpQuery = keyword
        this.$store.dispatch('dashboardEmployee/getRankingUser', {id: this.$route.params.id, searchEmpQuery: keyword})
      }, 500)
    }
  },
  watch: {
    rankingFile (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.paginations.searchQuery === '') {
          for (var x in newVal) {
            this.tempRanks[newVal[x].file_id] = newVal[x].rank
          }
        } else {
          for (var i in newVal) {
            newVal[i].rank = this.tempRanks[newVal[i].file_id]
          }
        }
      }
    },
    rankingUser (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.paginations.searchEmpQuery === '') {
          for (var x in newVal) {
            this.tempUserRanks[newVal[x].employee_id] = newVal[x].rank
          }
        } else {
          for (var i in newVal) {
            newVal[i].rank = this.tempUserRanks[newVal[i].employee_id]
          }
        }
      }
    },
    showCloseSearch (newVal) {
      if (!newVal) {
        this.$store.dispatch('dashboardEmployee/getRankingUser', {id: this.$route.params.id})
      }
    }
  },
  computed: {
    ...mapState({
      rankingUser: state => state.dashboardEmployee.rankingUser,
      rankingFile: state => state.dashboardEmployee.rankingFile,
      summary: state => state.dashboardEmployee.summary
    })
  },
  mounted () {
    this.$store.dispatch('dashboardEmployee/getRankingFile', {id: this.$route.params.id})
    this.$store.dispatch('dashboardEmployee/getRankingUser', {id: this.$route.params.id})
    this.$store.dispatch('dashboardEmployee/getSummary', {id: this.$route.params.id})
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/stylesheet/admin/vendor.scss";
@import '@/assets/stylesheet/vendor/detail_vendor.scss';
@import '@/assets/stylesheet/user/list_user.scss';
@import '@/assets/stylesheet/auth/dashboard.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Dashboard.vue